import {Mapper} from '@s-ui/domain'

export class FromJsonToTagCloudSeoRequestSeoMapper extends Mapper {
  constructor({config, tagCloudSeoRequestFactory}) {
    super()
    this._config = config
    this._tagCloudSeoRequestFactory = tagCloudSeoRequestFactory

    this._defaultCategoryId = this._config.get('search').DEFAULT_CATEGORY1_ID
    this._sectionIdMapping = this._config.get('page').SECTION_ID_MAPPING
    this._defaultOfferTypeId = this._config.get('search').DEFAULT_OFFER_TYPE_ID
    this._tagcloudEndpointsFromPageName =
      this._config.get('tagclouds').TAGCLOUD_ENDPOINTS_FROM_PAGE_NAME.HTTPSeoRepository
    this._tagcloudEndpoints = this._config.get('TAGCLOUD_ENDPOINTS')
    this._searchSectionIdMapping = this._config.get('SEARCH_SECTION_ID_MAPPING')
    this._makesWithHyphens = this._config.get('editorial').MAKES_WITH_HYPHENS
  }

  _getEndpointConfig = ({pageName, offerTypeId, context}) => {
    const hasContext = Boolean(context)
    if (hasContext) return this._tagcloudEndpoints[context]

    const endpointConfig = this._tagcloudEndpointsFromPageName[pageName] || {
      endpoint: '',
      params: {}
    }

    const hasMultipleConfigurations = endpointConfig instanceof Array

    if (hasMultipleConfigurations) {
      const selectedConfiguration = endpointConfig[offerTypeId]
      return selectedConfiguration || endpointConfig[this._defaultOfferTypeId]
    } else {
      return endpointConfig
    }
  }

  _getMakeFromNewsTerm = ({tag, searchTerm}) => {
    const term = tag || searchTerm
    if (!term) return

    const {key: makeWithHyphen} = this._makesWithHyphens.find(make => term.match(make.regex)) || {}

    if (makeWithHyphen) return makeWithHyphen

    const [make] = term.split('-')

    return make && make.replace('_', ' ')
  }

  _cleanNullValues = object =>
    Object.entries(object).reduce(
      (cleanObject, [key, value]) => (value == null ? cleanObject : ((cleanObject[key] = value), cleanObject)),
      {}
    )

  _getVersionParam = ({version}) => {
    const {ALLOWED_TAGCLOUD_VERSION_PARAMS} = this._config.get('tagclouds')

    return ALLOWED_TAGCLOUD_VERSION_PARAMS.includes(version) ? version : null
  }

  map = ({
    bodyTypeId,
    categoryId,
    context,
    filteredOfferTypeId,
    fuelTypeId,
    makeId,
    modelId,
    offerTypeId: paramOfferTypeId = this._defaultOfferTypeId,
    originUrl,
    pageName,
    priceRangeGroup,
    provinceId,
    regionId,
    searchTerm,
    seats,
    sellerTypeId,
    tag,
    transmissionTypeId,
    version,
    year
  }) => {
    const {OFFER_TYPE_NEW} = this._config.get('search')

    const offerTypeId = filteredOfferTypeId === OFFER_TYPE_NEW ? filteredOfferTypeId : paramOfferTypeId

    const {endpoint, params} = this._getEndpointConfig({
      pageName,
      offerTypeId,
      context
    })

    const make = this._getMakeFromNewsTerm({tag, searchTerm})

    const query = {
      bodyTypeId,
      fuelTypeId,
      make,
      makeId,
      modelId,
      name: params.name,
      originUrl,
      priceRangeGroup,
      provinceId: regionId ? null : provinceId,
      regionId,
      searchSectionId: params.searchSectionId,
      seats,
      sectionId: categoryId || this._defaultCategoryId,
      sellerTypeId,
      transmissionTypeId,
      version: this._getVersionParam({version}),
      year
    }

    return this._tagCloudSeoRequestFactory({
      endpoint,
      query: this._cleanNullValues(query)
    })
  }
}
